import qs from 'qs'

import request from '../lib/request'
import store from '../store'

const api = {
  get (endpoint, data, options) {
    return this.request('get', endpoint, data, options)
  },

  post (endpoint, data, options) {
    return this.request('post', endpoint, data, options)
  },

  put (endpoint, data, options) {
    return this.request('put', endpoint, data, options)
  },

  patch (endpoint, data, options) {
    return this.request('patch', endpoint, data, options)
  },

  del (endpoint, data, options) {
    return this.request('del', endpoint, data, options)
  },

  request (method, endpoint, data, options) {
    let url = `${process.env.VUE_APP_API_URL}${endpoint}`

    const headers = {
      'Accept': 'application/json'
    }

    if (store.state.login.token) {
      headers['Authorization'] = `Bearer ${store.state.login.token}`
    }

    if (store.state.currentRestaurant.data._id) {
      headers['Restaurant'] = store.state.currentRestaurant.data._id
    }

    if (store.state.currentProvider.data._id) {
      headers['Provider'] = store.state.currentProvider.data._id
    }

    if (store.state.userProvider) {
      headers['userProvider'] = store.state.userProvider
    }

    if (method === 'get') {
      if (data) {
        url += `?${qs.stringify(data)}`
      }
      return request('get', headers, url, null, options)
    } else {
      return request(method, headers, url, data, options)
    }
  }
}

export default api
